module.exports = __webpack_public_path__ + "img/Crillon.46d84161.svg";